import { render, staticRenderFns } from "./EtfMomentumPanel.vue?vue&type=template&id=11177668&scoped=true"
import script from "./EtfMomentumPanel.vue?vue&type=script&lang=js"
export * from "./EtfMomentumPanel.vue?vue&type=script&lang=js"
import style0 from "./EtfMomentumPanel.vue?vue&type=style&index=0&id=11177668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11177668",
  null
  
)

export default component.exports